// Libraries:
import { ChangeDetectorRef, Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { DateAdapter, MatDialogRef } from "@angular/material";
import { UserService } from "../../../service/user.service";
import { UsersChangesReportFilter } from '../../../persistence/dto/assign-changes-report-filter';
import { CampaignService } from '../../../core/services/campaign.service';
import { CampaignDTO } from '../../../core/models/campaignDTO.model';
import { FormBuilder, FormGroup, Validators,FormControl } from "@angular/forms";
import { distinctUntilChanged, map, skip, startWith, tap } from "rxjs/operators";

// Gigot:
import { CommercialStructureService } from "../../../core/services/commercial-structure.service";

@Component({
    selector: 'kt-dialog-user-inactive',
    templateUrl: './dialog-user-inactive.component.html',
    styleUrls: ['./dialog-user-inactive.component.scss'],
})
export class DialogUserInactiveComponent implements OnInit {

    campaignsFrom: CampaignDTO[] = [];
    campaignsTo: CampaignDTO[] = [];
    userInvalidReportForm: FormGroup;
    isLoadingResults: boolean = false;
 
    @ViewChild('searchInputDivision') searchInputDivision: ElementRef;
    @ViewChild('searchInputZone') searchInputZone: ElementRef;
    @ViewChild('searchInputArea') searchInputArea: ElementRef;
   
    resellerStatus;

    public zone: any;
    public zoneCtrl: FormControl = new FormControl();
    public zones: any;
    public filteredZones: any;

    constructor(
        public dialogRef: MatDialogRef<DialogUserInactiveComponent>,
        private fb: FormBuilder,
        private cdr: ChangeDetectorRef,
        private userService: UserService,
        private campaignService: CampaignService,
        private commercialService: CommercialStructureService,
      ) { }


    ngOnInit(): void {

        this.userInvalidReportForm = this.fb.group({
            campaignFrom: ['', Validators.required],
            campaignTo: ['', Validators.required],
            searchInputDivision : [],
            searchInputZone :[],
            searchInputArea : [],
            resellerStatus : []
          });
        this.initForm();
        this.getZones();
    }


    initForm(){
        
        this.loadCampaigns();
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    loadCampaigns(){
        this.campaignService.getCampaigns().subscribe(
            campaigns => {
              if (campaigns && campaigns.length > 0) {
                this.campaignsFrom = campaigns;
                this.campaignsTo = campaigns;
                //this.userInvalidReportForm.controls['campaignsTo'].setValue(0);
                //this.userInvalidReportForm.controls['campaignsFrom'].setValue(0);
              }
              this.cdr.detectChanges();
            },
            error => {
              this.cdr.detectChanges();
            }
          );
    }

    isControlHasError(controlName: string, validationType: string): boolean {
      const control = this.userInvalidReportForm.controls[controlName];
      if (!control) {
          return false;
      }

      return control.hasError(validationType) && (control.dirty || control.touched);
  }

  exportInformeBajas(){
        this.isLoadingResults = true;
        this.cdr.detectChanges();

        const controls = this.userInvalidReportForm.controls;
        if (this.userInvalidReportForm.invalid) {
            Object.keys(controls).forEach(controlName => {
                    controls[controlName].markAsTouched();
                }
            );
            return;
        }

        let data =  this.filterConfiguration()
        
        console.log(data);

        if(this.userInvalidReportForm.controls['campaignTo'].value < this.userInvalidReportForm.controls['campaignFrom'].value)
        {
          this.isLoadingResults = false; 
          this.cdr.detectChanges();
          window.alert("La campaña 'desde' elegida no puede ser posterior a la de 'hasta'");
        }
        else
        {
          this.exportExcel(this.userService.downloadUsersInactive(data), "InformeDeBajas.xlsx");  

        }
    }


    /** FILTRATION */
    filterConfiguration(): any {
      let filter = this.userInvalidReportForm.value;

      if (this.searchInputZone && this.searchInputZone.nativeElement.value) {
        filter.searchInputZone = this.searchInputZone.nativeElement.value;
      } else { filter.searchInputZone = 0 }

      if (this.searchInputDivision && this.searchInputDivision.nativeElement.value) {
        filter.searchInputDivision = this.searchInputDivision.nativeElement.value;
      } else { filter.searchInputDivision = 0 }
    
      if (this.searchInputZone && this.searchInputArea.nativeElement.value) {
        filter.searchInputArea = this.searchInputArea.nativeElement.value;
      } else { filter.searchInputArea = 0 }

      if (this.resellerStatus != undefined) {
        filter.resellerStatus = this.resellerStatus;
      } else { filter.resellerStatus = null }
      
      return filter;
    }


    exportExcel(request, filename) {
        request.subscribe(x => { saveAs(x, filename), this.isLoadingResults = false; this.cdr.detectChanges(); },
            error => { alert('Error al descargar el archivo'), this.isLoadingResults = false;  this.cdr.detectChanges(); });
    }

    resellerStatusChanged($event) {
      this.resellerStatus = $event.value;
    }

    public getZones(): void {
      this.commercialService.getZonesByUser().subscribe(res => {
          this.zones = res;
          if (this.zones.length === 1) {
              this.zone = this.zones[0];
              this.zoneCtrl.disable();
          }
          this.filteredZones = this.zoneCtrl.valueChanges.pipe(
              startWith(""),
              map((zones) =>
                  zones
                      ? this.filterZones(zones)
                      : this.zones.slice()
              )
          );
          this.cdr.detectChanges();
      })
    }

    private filterZones(value: string): void {
      const filterValue = value.toLowerCase();
      return this.zones.filter(
          (zone: any) => zone.indexOf(filterValue) === 0
      );
    }

}